var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C10.1134 0 9.8 0.313401 9.8 0.7C9.8 1.0866 10.1134 1.4 10.5 1.4L11.61 1.4L8.60503 4.40503C8.33166 4.67839 8.33166 5.12161 8.60503 5.39497C8.87839 5.66834 9.32161 5.66834 9.59497 5.39497L12.6 2.38995L12.6 3.5C12.6 3.8866 12.9134 4.2 13.3 4.2C13.6866 4.2 14 3.8866 14 3.5L14 0.7C14 0.313401 13.6866 0 13.3 0H10.5ZM1.4 11.61L1.4 10.5C1.4 10.1134 1.0866 9.8 0.7 9.8C0.3134 9.8 0 10.1134 0 10.5L2.3977e-06 13.3C2.69769e-06 13.6866 0.313403 14 0.700002 14H3.5C3.8866 14 4.2 13.6866 4.2 13.3C4.2 12.9134 3.8866 12.6 3.5 12.6H2.38995L5.39497 9.59497C5.66834 9.32161 5.66834 8.87839 5.39498 8.60502C5.12161 8.33166 4.67839 8.33166 4.40503 8.60502L1.4 11.61Z",
    fill: "#6E6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximise);
export default __webpack_public_path__ + "static/media/maximise.9ec25c5f04edd3ced910825c9568cf6d.svg";
export { ForwardRef as ReactComponent };